import type { WalletProvider } from '../../wallets/walletProvider';
import { DYNAMIC_WAAS_METADATA } from '../constants';
import type { WaasWalletProvider } from '../waas.types';

export const isWaasWalletProvider = (
  walletProvider: WalletProvider
): walletProvider is WaasWalletProvider => {
  return walletProvider.key.includes(
    DYNAMIC_WAAS_METADATA.normalizedWalletName
  );
};
